const DecreasingIcon = () =>
{
      return (
            <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="none"
                  viewBox="0 0 16 16"
            >
                  <path
                        fill="#CFD7E8"
                        d="M7.336 3.473v7.446L4.083 7.666a.67.67 0 0 0-.947 0c-.26.26-.26.68 0 .94l4.394 4.393c.26.26.68.26.94 0l4.393-4.393a.664.664 0 1 0-.94-.94L8.67 10.919V3.473c0-.367-.3-.667-.667-.667s-.667.3-.667.667"
                  ></path>
            </svg>
      )
}

export default DecreasingIcon;